module.exports = __webpack_public_path__ + "img/no.c94a8dcf.jpg";